import React, { useState } from "react";
import { Stack, HStack, Collapse, Box } from "@chakra-ui/react";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";

function Links({ routes, onLinkClick, activePath, size = 0 }) {
  const [openDropdown, setOpenDropdown] = useState(null);

  // Helper function to check if the active path is in subRoutes
  const isActivePathInSubRoutes = (subRoutes) => {
    if (!subRoutes) return false;
    return subRoutes.some((subRoute) =>
      subRoute.path === activePath || isActivePathInSubRoutes(subRoute.subRoutes)
    );
  };

  const handleLinkClick = (path) => {
    const route = routes.find((route) => route.path === path);
    if (route && route.subRoutes) {
      setOpenDropdown(openDropdown === path ? null : path);
    } else {
      onLinkClick(path);
    }
  };

  return (
    <Stack direction="column" mt="8px" spacing="4">
      {routes.map((route, index) => {
        const isSubRouteActive = isActivePathInSubRoutes(route.subRoutes);
        const isActive = activePath === route.path || isSubRouteActive;
        return (
          <React.Fragment key={index}>
            <HStack
              justifyContent={route.subRoutes ? "space-between" : "flex-start"}
              className={`sidebar-Icon ${activePath === route.path ? "active" : ""
                } ${isActive ? "MainRoute" : ""}`}
              cursor="pointer"
              spacing="22px"
              onClick={() => handleLinkClick(route.path)}
              p="8px"
              borderRadius="md"
            >
              {route.icon}
              <div
                style={{
                  fontSize: size > 0 ? "1rem" : null,
                  fontWeight: activePath === route.path ? "bold" : "500",
                  cursor: "pointer ",
                  textAlign: "right",
                }}
              >
                {route.name}
              </div>
              {route.subRoutes && (
                <Box>
                  {openDropdown === route.path ? (
                    <MdArrowDropUp />
                  ) : (
                    <MdArrowDropDown />
                  )}
                </Box>
              )}
            </HStack>
            {route.subRoutes && (
              <Collapse in={openDropdown === route.path}>
                <Stack pl="40px" spacing="2">
                  <Links
                    size={1}
                    routes={route.subRoutes}
                    onLinkClick={onLinkClick}
                    activePath={activePath}
                  />
                </Stack>
              </Collapse>
            )}
          </React.Fragment>
        );
      })}
    </Stack>
  );
}

export default Links;
